export default __webpack_public_path__ + "static/media/icn_error.4286e661.svg";